import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth, formatError } from "@/context/AuthContext";
import { useSite } from "@/context/SiteContext";

export default function AdminLogin() {
  const { login, admin } = useAuth();
  const s = useSite();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (admin) navigate("/admin"); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full rounded-xl border border-slate-200 pl-11 pr-4 py-3 text-sm focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none";

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center mb-8">
          <img src={s.logo} alt="Chouhan Taxi Service" className="h-16 w-16 rounded-full object-cover mx-auto mb-4 ring-2 ring-brand-light" />
          <h1 className="font-heading font-bold text-navy-heading text-2xl">Admin Panel</h1>
          <p className="text-sm text-slate-500 mt-1">Chouhan Taxi Service</p>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div className="relative">
            <User className="w-4 h-4 text-slate-400 absolute left-4 top-1/2 -translate-y-1/2" />
            <input className={inputCls} placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} data-testid="admin-username-input" />
          </div>
          <div className="relative">
            <Lock className="w-4 h-4 text-slate-400 absolute left-4 top-1/2 -translate-y-1/2" />
            <input type="password" className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
          </div>
          <button disabled={loading} className="w-full flex items-center justify-center gap-2 bg-brand hover:bg-royal text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-70" data-testid="admin-login-btn">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : null} {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
